function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module cloud-services/cloudservicescore
 */
import { ContextPlugin } from 'ckeditor5/src/core';
import Token from './token/token';
import UploadGateway from './uploadgateway/uploadgateway';
/**
 * The `CloudServicesCore` plugin exposes the base API for communication with CKEditor Cloud Services.
 *
 * @extends module:core/contextplugin~ContextPlugin
 */

var CloudServicesCore =
/*#__PURE__*/
function (_ContextPlugin) {
  _inherits(CloudServicesCore, _ContextPlugin);

  function CloudServicesCore() {
    _classCallCheck(this, CloudServicesCore);

    return _possibleConstructorReturn(this, _getPrototypeOf(CloudServicesCore).apply(this, arguments));
  }

  _createClass(CloudServicesCore, [{
    key: "createToken",

    /**
     * Creates the {@link module:cloud-services/token~Token} instance.
     *
     * @param {String|Function} tokenUrlOrRefreshToken Endpoint address to download the token or a callback that provides the token. If the
     * value is a function it has to match the {@link module:cloud-services/token~refreshToken} interface.
     * @param {Object} [options]
     * @param {String} [options.initValue] Initial value of the token.
     * @param {Boolean} [options.autoRefresh=true] Specifies whether to start the refresh automatically.
     * @returns {module:cloud-services/token~Token}
     */
    value: function createToken(tokenUrlOrRefreshToken, options) {
      return new Token(tokenUrlOrRefreshToken, options);
    }
    /**
     * Creates the {@link module:cloud-services/uploadgateway/uploadgateway~UploadGateway} instance.
     *
     * @param {module:cloud-services/token~Token} token Token used for authentication.
     * @param {String} apiAddress API address.
     * @returns {module:cloud-services/uploadgateway/uploadgateway~UploadGateway}
     */

  }, {
    key: "createUploadGateway",
    value: function createUploadGateway(token, apiAddress) {
      return new UploadGateway(token, apiAddress);
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'CloudServicesCore';
    }
  }]);

  return CloudServicesCore;
}(ContextPlugin);

export { CloudServicesCore as default };